<div class="modal-header d-flex align-items-center">
  <h5 class="modal-title" id="modal-title">{{ title }}</h5>
</div>
<div class="modal-body" style="padding-top: 0px">
  <div class="mt-2" style="text-align: center">
    <i class="far fa-check-circle text-success mb-3" style="font-size: 6em"></i>
    <p class="m-0" style="color: #404040; font-size: 14px; font-weight: 600">
      {{ subtitle }}
    </p>
    <p class="m-0" style="color: #404040; font-size: 14px; font-weight: 600">
      {{ description }}
    </p>
  </div>
</div>
<div class="modal-footer standard-footer">
  <app-standard-footer-buttons
    [secondaryLabel]="'Criar novo checklist'"
    [primaryLabel]="'Importar interações'"
    (secondaryClick)="modal.close('NEW_CHECKLIST')"
    (primaryClick)="modal.close('IMPORT')">
  </app-standard-footer-buttons>
</div>
